module.exports = __webpack_public_path__ + "img/icon-team-4.d201b40e.svg";